import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../../api/request';
import { createFetchContext } from '../../../../../components/contexts/FetchContextFactory';
import { getFormData } from '../../api';
import { ClassroomOptionsResponse } from '../../types';

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  ClassroomOptionsResponse,
  AxiosResultDefaultError
>();

export function useClassroomOptionsLoader() {
  return useFetch();
}

export const ClassroomOptionsLoaderConsumer = FetchConsumer;

export default function ClassroomOptionsLoader({ children }: BaseLoaderProps) {
  const request = useCallback(async () => {
    return getFormData();
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      {children}
    </FetchProvider>
  );
}
